@if (list) {
  <table-material
    id-table="error-code-id-notmapped"
    [header]="header"
    [data]="list"
    [getValue]="getData"
    [selectable]="false"
    [additionalRowActionsTemplate]="setValueAction"
    (onRefresh)="refresh()">
  </table-material>
}


<ng-template #setValueAction let-value="value" let-index="index">

  @if (!value.Value) {
    <button mat-icon-button (click)="onCopyErrorCode({index:index, value:value})" matTooltip="Copy this ErrorCode">
      <mat-icon>content_copy</mat-icon>
    </button>
  }

</ng-template>
